

const WhyUsHero = () => {
    return (
        <section className="bg-[#98c5c5] py-20 px-2 flex flex-col items-center">
            <h3 className="text-4xl text-center sm:text-[60px] leading-[70px] sm:font-semibold mb-10 sm:mb-5 ">All in One Pharmacy to simplify your life</h3>
            <p className=" text-lg px-2 text-center sm:text-[26px] font-serif">Vitamins, inhalers, creams, syrups all your medical needs at one place.</p>
            <div>
                <img className="h-[150px] sm:h-[340px] mt-10 sm:mt-5" src="https://pillup.com/assets/Why%20Us/heroImg.png" alt="PillUp medication" />
            </div>
        </section>
    )
}

export default WhyUsHero